// Utils
import { API_DOWNLOAD_MAKER_REPORT, API_FETCH_MAKER_LIST, API_GENERATE_MAKER_REPORT, API_GET_ACTIVE_MAKER_REPORT_CUSTOM, API_GET_MAKER_ACTIVE_REPORT, API_GET_STATIC_DATA } from '../../../utils/API/apiUrls';

import { GET, POST } from '../../../utils/fetchWrappers';

// API URLs

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as makerActions from './maker.actions';

// constants
import { DOWNLOAD_MAKER_REPORT_REQUEST, FETCH_MAKER_LIST, FETCH_MAKER_LIST_REQUEST, GENERATE_MAKER_REPORT_REQUEST, GET_ACTIVE_MAKER_REPORT_REQUEST, GET_STATIC_DATA_REQUEST_MAKER } from './maker.constants';

// Libs
import { takeLatest, put, call } from 'redux-saga/effects';
import moment from 'moment';
import { MOCK_API_VALUE } from 'utils/constants/commonValues';
import { makergetres } from 'mockApiWiseReqRes';
import { MakerDataListRequest } from './dto/MakerDataListRequest.dto';
import { MakerReportRequest } from './dto/MakerReportRequest.dto';
import { toast } from 'react-toastify';

export function* fetchMakerDataList(actions) {
    yield put(makerActions.showLoader());
    yield put({ type: FETCH_MAKER_LIST}); // triggers loading
    try {
        const { payload } = actions;
        const res = new MakerDataListRequest(payload);
        let data;
        if (MOCK_API_VALUE) {
            data = makergetres();
        } else {
            const resp = yield call(POST, API_FETCH_MAKER_LIST, res);
            data = resp.data;
        }

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(makerActions.fetchMakerSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                makerActions.fetchMakerError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(makerActions.fetchMakerError({ error: data }));
    }
    yield put(makerActions.hideLoader());
}

export function* generateMakerReport(actions) {
    yield put(makerActions.showLoader());
    try {
        const { payload } = actions;
        const request = new MakerReportRequest(payload);
        const { data } = yield call(POST, API_GENERATE_MAKER_REPORT, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(makerActions.generateReportSuccess(data));
        } else if (data && data.errorMessage) {
            const errorMessage = data.errorMessage || '';
            yield put(
                makerActions.generateReportError({
                    error: errorMessage || '',
                })
            );
            if (errorMessage) {
                toast.error(errorMessage);
            }
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage || '';
        yield put(
            makerActions.generateReportError({
                error: errorMessage || '',
            })
        );
        if (errorMessage) {
            toast.error(errorMessage);
        }
    }
    yield put(makerActions.hideLoader());
}

export function* downloadReportRequest(actions) {
    yield put(makerActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            requestId: payload.requestId,
        };
        const { data } = yield call(POST, API_DOWNLOAD_MAKER_REPORT , request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(makerActions.downloadMakerReportSuccess(data.presignedUrl));
            if (data.presignedUrl) {
                const link = document.createElement('a');
                link.href = data.presignedUrl;
                link.target = '_blank';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } else if (data && data.errorMessage) {
            yield put(
                makerActions.downloadMakerReportError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            makerActions.downloadMakerReportError({
                error: data,
            })
        );
    }
    yield put(makerActions.hideLoader());
}

export function* getActiveReportDetails(actions) {
    yield put(makerActions.showLoader());
    try {
        const { data } = yield call(
            GET,
            actions?.payload?.reportType
                ? API_GET_ACTIVE_MAKER_REPORT_CUSTOM(actions.payload.reportType)
                : API_GET_MAKER_ACTIVE_REPORT
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(makerActions.getActiveMakerReportSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                makerActions.getActiveMakerReportError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            makerActions.getActiveMakerReportError({
                error: data,
            })
        );
    }
    yield put(makerActions.hideLoader());

}

export function* getStaticData(actions) {
    yield put(makerActions.showLoader());
    try {
        const { data } = yield call(GET, API_GET_STATIC_DATA(actions.payload.screenType));
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(makerActions.getStaticDataSuccessMaker(data));
        } else if (data && data.errorMessage) {
            yield put(
                makerActions.getStaticDataErrorMaker({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            makerActions.getStaticDataErrorMaker({
                error: data,
            })
        );
    }
    yield put(makerActions.hideLoader());
}

export function* MakerSaga() {
    yield takeLatest(FETCH_MAKER_LIST_REQUEST, fetchMakerDataList);
    yield takeLatest(GENERATE_MAKER_REPORT_REQUEST, generateMakerReport);
    yield takeLatest(GET_ACTIVE_MAKER_REPORT_REQUEST, getActiveReportDetails);
    yield takeLatest(DOWNLOAD_MAKER_REPORT_REQUEST, downloadReportRequest);
    yield takeLatest(GET_STATIC_DATA_REQUEST_MAKER, getStaticData);
}
